import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4a428bb1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  "class": "u-toast"
};
var _hoisted_2 = {
  "class": "text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "fade",
    onAfterEnter: _ctx.afterEnter,
    css: _ctx.options.useTransition
  }, {
    "default": _withCtx(function () {
      return [_ctx.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.options.text), 1)])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["onAfterEnter", "css"]);
}